export default "__VITE_PUBLIC_ASSET__a2a8fdda__"